import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("EXPIRED\n",{ moduleName: "client-portal/components/payment-link/expired.hbs" })